module.exports = __webpack_public_path__ + "img/comuniquemonos-new.c808972a.jpg";